module.exports = __webpack_public_path__ + "img/chatbot_cn.c4d0789b.svg";